export default {
  address: {
    name: '收件人',
    list: '地址列表',
    address: '地址',
    region: '區號',
    mobile: '電話號碼',
    detail: '詳細地址',
    save: '保存並使用',
    create: '新建地址',
    inputDetail: '請填寫詳細信息',
    select: '請輸入地址',
    notice: '請填寫與身份證明文件相同的名字'
  },
  checkout: '結算',
  totalPrice: '總計',
  noTariff: '不含關稅及運費',
  total: '共',
  products: '件商品',
  order: {
    create: '提交訂單',
    tariff: '關稅',
    shippingFee: '運費',
    discount: '優惠折扣',
    remarks: '買家留言',
    couponCode: '優惠碼',
    useCoupon: '使用優惠',
    shippingMethod: '配送方式',
    selfPickup: '自取',
    mail: '快遞',
    orderNumber: '訂單號',
    paymentStatus: {
      status: '訂單裝填',
      P: '等待付款',
      S: '已付款',
      F: '付款失敗'
    },
    orderTime: '下單時間',
    totalAmount: '總金額',
    alert: '提醒',
    failAlert: '提交前請確保你已填寫地址(如適用)﹐聯絡電話及確認條款',
    useCredit: '使用積分優惠',
    orderDetail: '帳單詳情',
    phoneNumber: '－ 如選擇自取只需提供電話號碼',
    agree: '本人已閱讀並明白及同意',
    agreement: '用户網購條款',
    notice: '－ 客人如果對其準備下單的網購產品有任何疑問﹐請客人不應下單避免不必要的爭議。',
    fillUp: '－ 客人請確保已填寫',
    address: '地址(如適用)',
    client: '－ 客人請確保已',
    confirm: '確認條款。',
    customerService: '－ 自取地址詳情請聯絡客戶服務主任。',
  },
  payment: {
    pay: '確認付款',
    method: '付款方式',
    wechat: '微信付款',
    stripe: '信用卡付款',
    transfer:"轉帳付款",
    cash: '現金付款',
    makingPayment: '付款中',
    errorPayment: '付款失敗，請稍後再試',
    errorCard: '請正確輸入信用卡號碼',
    info: '付款詳情',
    orderNumber: '訂單號碼',
    actualAmount: '付款金額',
    currency: '貨幣',
    waitingConfirm: '等待確認',
    success: '付款成功',
    backToOrder: '查看我的訂單',
    backToShop: '查看我的商品',
    shareMsg: '到我的商品分享給其他人，能夠獲得回贈哦！ ',
    pending:"等待批核",
    repay:"重新上傳",
    reject:"轉帳失敗"
  },
  emptyMsg:{
      cart:'快點給我挑點商品 T.T',
      order:'暫無訂單記錄',
  },
  logistic: {
		ordered: '未出貨',
		packaged: '已包裝',
		delivered: '已發貨',
		received: '已收貨',
		confirm: '確認收貨',
    cancel: '取消訂單', 
    cancelConfirm: '你是否確認取消訂單？',
		receiveConfirm: '你是否確認已收取貨物？'
	}
}


// WEBPACK FOOTER //
// ./src/Cart/langs/zh_hk/index.js